import DotsOptionsMenu from "../../../../components/Menus/DotsOptionsMenu";
import { isoStringToFormat } from "../../../../utils/DateUtils";
import { ImageCardViewProps } from "./ImageCardGrid";
import Constants from "../../../../utils/Constants";
import ImageCardOptions from "./ImageCardOptions";

const ImageCardList = ({
  onClick,
  infoClick,
  deleteClick,
  fetchedFile,
  setFileToTranslate,
  isSelected,
  contact,
  handleSelect,
  onTranscribe,
}: ImageCardViewProps) => {
  const isIndexed = Boolean(fetchedFile?.Index);
  return (
    <div
      className={`tw:rounded-sm tw:px-2 tw:py-3 tw:w-full tw:md:w-70 tw:lg:w-76 tw:xl:w-88 tw:relative tw:flex tw:flex-col tw:justify-center tw:cursor-pointer
        ${isSelected ? "bg-primary-selected tw:text-dark" : ""} 
        tw:shadow-[0px_2px_8px_rgba(0,0,0,0.15)]`}
      onClick={(e) => {
        e.stopPropagation();
        handleSelect();
      }}
    >
      <div className="tw:flex tw:items-center tw:cursor-pointer">
        {fetchedFile?.Type?.startsWith("image") ? (
          <img
            src={fetchedFile.URL}
            style={{ width: 64, height: 64, objectFit: "cover" }}
            alt=""
            className="tw:ml-1 tw:rounded-sm"
          />
        ) : (
          <i
            style={{ width: 64, height: 64, fontSize: 50 }}
            className={`mdi mdi-${getFileIcon(
              isIndexed
            )} tw:flex tw:justify-center tw:items-center tw:border tw:border-lighter tw:rounded-sm`}
          />
        )}
        <div className="tw:ml-2 tw:mr-1" style={{ width: "calc(100% - 75px)" }}>
          <div>
            <h4
              onClick={(e) => {
                e.stopPropagation();
                onClick();
              }}
              className="tw:mb-0 tw:text-dark tw:pr-2 tw:truncate tw:hover:underline tw:hover:text-primary tw:transition-colors"
              style={{ width: "calc(100% - 25px)", minWidth: 180 }}
            >
              {fetchedFile.Name}
            </h4>
            <div
              onClick={(e) => e.stopPropagation()}
              style={{ position: "absolute", right: 10, top: 5 }}
            >
              <DotsOptionsMenu
                options={
                  <ImageCardOptions
                    deleteFile={deleteClick}
                    file={fetchedFile}
                    openInfo={infoClick}
                    onTranslate={
                      setFileToTranslate
                        ? () => setFileToTranslate(fetchedFile)
                        : undefined
                    }
                    onTranscribe={onTranscribe}
                  />
                }
                dotsSize={20}
              />
            </div>
          </div>

          <div className="tw:mx-0 tw:font-medium tw:truncate tw:text-darker tw:pr-2 tw:mb-0 tw:text-xs">
            {fetchedFile.Caption || ""}
          </div>
          <p
            style={{ fontSize: 11 }}
            className="tw:mb-1 tw:mt-0"
          >{`Uploaded by ${
            contact?._RecordName || "(No Name)"
          }, ${isoStringToFormat(
            fetchedFile?.UploadedDate,
            Constants.FIELDTYPES.DATE_TIME || "--"
          )}`}</p>
        </div>
      </div>
    </div>
  );

  function getFileIcon(isIndexed: boolean) {
    if (fetchedFile?.Type?.startsWith("video/")) {
      if (fetchedFile?.Transcript) return "play-protected-content";
      return "play-box-outline";
    }

    return isIndexed ? "file-document-check-outline" : "file-document-outline";
  }
};

export default ImageCardList;
